import { render, staticRenderFns } from "./grademanagement-teacherlist.vue?vue&type=template&id=a3224904&scoped=true"
import script from "./grademanagement-teacherlist.vue?vue&type=script&lang=js"
export * from "./grademanagement-teacherlist.vue?vue&type=script&lang=js"
import style0 from "./grademanagement-teacherlist.vue?vue&type=style&index=0&id=a3224904&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3224904",
  null
  
)

export default component.exports